export default __webpack_public_path__ + "static/media/Lab-department.7d82c4cd.jpg";